import { ReactFlowProvider } from "reactflow";
import { Drawer } from "../../components/Drawer";
import OracleFlow from "./OracleFlow";

import "reactflow/dist/base.css";
import styles from "../../../styles/containers/oraculo/oracle-drawer.module.scss";
import { ProgressModal } from "./ProgressModal";
import CdpFlow from "./CdpFlow";

export default function AudienceFilters({
  visible,
  boxes = [],
  links = [],
  audience,
  sort,
  limit,
  in_progress,
  disabledVariables = [],
  onClose,
  onQuery,
  onDelete,
  totals,
}) {
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      withoutTransition
      direction="full-center"
      showCloseButton={false}
    >
      <div className={styles.oracle} id="oracle-flow">
        <div className={styles.oracleHeader}>
          <div className="d-flex flex-column">
            <p className={styles.title}>{audience?.name}</p>
          </div>
          <div className={styles.close} onClick={onClose}>
            <i className="fas fa-times" />
          </div>
        </div>

        <div className={styles.flow}>
          <ReactFlowProvider>
            <CdpFlow
              boxes={boxes}
              links={links}
              sort={sort}
              limit={limit}
              onClose={onClose}
              onQuery={onQuery}
              onDelete={onDelete}
              audience={audience}
              disabledVariables={disabledVariables}
            />
          </ReactFlowProvider>

          <div className={styles.totalCustomers}>
            <div className={styles.updatedAt}>Última edição em: {formatDate(audience?.updated_at)}</div>
            <div className={styles.total}>{totals} clientes</div>
          </div>
        </div>
      </div>

      {in_progress && <ProgressModal />}
    </Drawer>
  );
}
